import { SettingsRequestError } from "./api";
import type { ManualImageJobStatus, ManualImageMetadataSource } from "./types";

export const DEFAULT_MANUAL_IMAGE_NEGATIVE_PROMPT = "worst quality, low quality, blurry, bad anatomy, bad hands, extra fingers, missing fingers, extra limbs, deformed, watermark, text, signature";

export function isManualImageTerminal(status: ManualImageJobStatus, recoveryPending = false): boolean {
  void recoveryPending;
  return status === "delivered" || status === "failed";
}

export function manualImageMetadataSourceLabel(source: ManualImageMetadataSource): string {
  if (source === "request" || source === "settings_snapshot") return "请求设置";
  if (source === "generation_result") return "实际生成结果";
  return "上游未返回";
}

const MANUAL_IMAGE_REQUEST_BODY_CODES = new Set([
  "manual_image_request_invalid",
  "manual_image_request_id_invalid",
  "manual_image_positive_prompt_invalid",
  "manual_image_negative_prompt_invalid",
]);

function safeSettingsRequestCode(code: string | undefined): string | undefined {
  return code && /^[a-z0-9_-]{1,100}$/.test(code) ? code : undefined;
}

function withErrorCode(message: string, code: string): string {
  return `${message}（错误代码：${code}）`;
}

export function manualImageSubmissionErrorMessage(error: unknown): string {
  if (error instanceof SettingsRequestError) {
    const code = safeSettingsRequestCode(error.code);
    if (code === "manual_image_settings_invalid") {
      return withErrorCode("当前模型或图片参数无效，请重新保存设置后再试。", code);
    }
    if (code === "manual_image_request_conflict") {
      return withErrorCode("同一请求 ID 已用于不同题词，请刷新 Activity 后重新提交。", code);
    }
    if (code === "manual_image_active_job_exists") {
      return withErrorCode("你已有一项正在处理的生图任务。请等待其完成、失败或取消后再提交。", code);
    }
    if (code === "session_invalid_or_expired") {
      return withErrorCode("Activity 会话已失效，请从 Discord 重新打开 Activity 后再试。", code);
    }
    if (code === "activity_origin_forbidden") {
      return withErrorCode("当前 Activity 来源没有提交权限，请从 Discord 内重新打开。", code);
    }
    if (code && MANUAL_IMAGE_REQUEST_BODY_CODES.has(code)) {
      return withErrorCode("任务请求内容不符合服务端要求，请刷新 Activity 后重试。", code);
    }
    const message = "任务提交结果暂时无法确认。使用相同题词重试会复用同一请求 ID。";
    return code ? withErrorCode(message, code) : message;
  }
  return "任务提交结果暂时无法确认。使用相同题词重试会复用同一请求 ID。";
}
